import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Header } from '@aptsi-types';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { TableService } from './table.service';

@Component({
  selector: 'aptsi-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit {
  @Input() haveUpdateDelete: boolean = true;
  @Input() haveUpdate: boolean = true;
  @Input() haveDelete: boolean = true;
  @Input() haveCapture: boolean = false; 
  @Input() haveCheck: boolean = false; 
  @Input() isSort: boolean = true;

  @Input() isClickDisabled: boolean = false;
  @Input() isDragDropEnabled: boolean = false;
  @Input() isCheckBoxEnabled: boolean = false;
  @Input() headers: Header[];
  @Input() data: any[];
  @Input() columnStyles: { [key: number]: (value: any) => string } = {};  // Function to map value to style
  @Output() updateClicked = new EventEmitter<number>();
  @Output() deleteClicked = new EventEmitter<number>();
  @Output() captureClicked = new EventEmitter<number>();
  @Output() checkClicked = new EventEmitter<number>();
  @Output() selectionChanged = new EventEmitter<number[]>();
  @Input() isRowSelected: (row: any) => boolean;

  
  sortDirection: { [key: string]: 'asc' | 'desc' } = {};

  clickedRows: number[] = [];
  

  constructor(private tableService: TableService ) {}

  ngOnInit(): void {

    this.tableService.getCheckBox().subscribe(rows => {
      this.clickedRows = rows;
    });
    this.tableService.resetClickedRows()
  }
  
  ngOnChanges() {
    if (this.clickedRows && this.clickedRows.length > 0) {
      // Sync checkboxes with external clickedRows
      this.tableService.updateClickedRows(this.clickedRows);
    }
  }

  onRowClick(index: number) {
    if (this.isClickDisabled && !this.clickedRows.includes(index)) {
      this.checkClicked.emit(index);
      this.clickedRows.push(index);
    }
  }
 

  toggleHeaderCheckbox(header: any) {
    header.checked = !header.checked;
  }

  check(index: number) {
    this.checkClicked.emit(index);
  }

  update(index: number) {
    this.updateClicked.emit(index);
  }

  delete(index: number) {
    this.deleteClicked.emit(index);
  }

  capture(index: number) {
    this.captureClicked.emit(index);
  }



toggleRowSelection(index: number, event: any) {
  if (event.target.checked) {
    if (!this.clickedRows.includes(index)) {
      this.clickedRows.push(index);
    }
  } else {
    this.clickedRows = this.clickedRows.filter(row => row !== index);
  }

  this.selectionChanged.emit([...this.clickedRows]); // Emit updated selected indexes
  this.tableService.updateClickedRows(this.clickedRows);
  console.log("Updated Clicked Rows:", this.clickedRows);
}

// toggleRowSelection(index: number, event: any) {
//   if (event.target.checked) {
//     if (!this.clickedRows.includes(index)) {
//       this.clickedRows.push(index);
//     }
//   } else {
//     this.clickedRows = this.clickedRows.filter(row => row !== index);
//   }

//   this.selectionChanged.emit([...this.clickedRows]); // Emit updated selected indexes
//   console.log("Updated Clicked Rows:", this.clickedRows);
// }


  toggleSelectAll(event: any) {
    if (event.target.checked) {
      this.clickedRows = this.data.map((_, i) => i); // Select all rows
    } else {
      this.clickedRows = []; // Deselect all rows
    }
    this.selectionChanged.emit(this.clickedRows); // Emit selected indexes
    this.tableService.updateClickedRows(this.clickedRows);
    console.log(this.clickedRows);
  }

  sortData(property: string) {
    // Reset sorting for other columns
    Object.keys(this.sortDirection).forEach(key => {
      if (key !== property) {
        delete this.sortDirection[key];
      }
    });
  
    // Toggle sorting state for the selected column
    if (!this.sortDirection[property]) {
      this.sortDirection[property] = 'asc';
    } else if (this.sortDirection[property] === 'asc') {
      this.sortDirection[property] = 'desc';
    } else {
      delete this.sortDirection[property]; // Reset sorting state
      this.data = [...this.data]; // Reset data to original order (if applicable)
      return;
    }
  
    this.data.sort((a, b) => {
      const valueA = a[property];
      const valueB = b[property];
  
      if (valueA < valueB) {
        return this.sortDirection[property] === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection[property] === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
  }
  
  

  // Function to handle drag-and-drop reordering
  drop(event: CdkDragDrop<any[]>) {
    if(this.isDragDropEnabled){
      moveItemInArray(this.data, event.previousIndex, event.currentIndex);
    }
  }

  getColumnStyle(colIndex: number, cellValue: any): string {
    
    
    if (this.columnStyles[colIndex]) {
      return this.columnStyles[colIndex](cellValue);
    }
    return '';  // Return an empty string if no style function is defined for the column
  }
  

}
